export default __webpack_public_path__ + "static/media/isi.90d20f19.png";